import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import PropTypes from 'prop-types';
import { NavDropDownContent } from '../../NavDropDownContent';

const StyledHeading = styled(Heading, {
  '&.abyss-heading-root': {
    marginTop: '16px',
    padding: '8px 16px',
    fontWeight: 'bold',
    fontSize: '18px',
    color: '$gray8 !important',
  },
});

export const ContentContainer = ({ heading, dropdownKey }) => {
  return (
    <React.Fragment>
      <StyledHeading offset={4}>{heading}</StyledHeading>
      <NavDropDownContent dropdownKey={dropdownKey} />
    </React.Fragment>
  );
};

ContentContainer.propTypes = {
  heading: PropTypes.string.isRequired,
  dropdownKey: PropTypes.string.isRequired,
};
